var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.students),function(student){return _c('div',{key:student.id,staticClass:"student-item p-3 cursor-grab mb-2",attrs:{"draggable":"true"},on:{"dragstart":($event) => _vm.dragStart(student, $event)}},[_vm._v("\n    "+_vm._s(student.name)+"\n  ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }